import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Input from "../../_default/Input";
import "./Superset.scss";
import Exercise from "./Exercise";
import Icon from "../../_default/Icon";
import {parse, stringify} from "flatted";

export default function Superset({previousValues, setSupersets, supersets, setName, isPersonal, error, isAdmin, set, set_idx, removeSet, exercises, removeExercise, onClickSearch, onChange, setsAmount }) {
  const [setOfFirst, setSetOfFirst] = useState(false);
  const [oldSetAmount, setoldSetAmount] = useState(set?.exercises[0]?.sets ? set?.exercises[0]?.sets : 1);

  const addSubs = (item) => {
    set.exercises.forEach((exercise, idx) => {
      let _exercise = {...exercise};

      Object.defineProperty(_exercise, '_exercise', {
        // value: 42,
        writable: false,
        configurable: true
      });


      delete _exercise.subexercises;

      if(oldSetAmount < item){
        setoldSetAmount(set.exercises[0].sets)
        onChange(_exercise, 'addSubexercise', idx, set_idx);
      }else{
        setoldSetAmount(set.exercises[0].sets)
        onChange(_exercise, 'removeSubexercise', idx, set_idx);
      }
    })
  }
  
  return (
    <Draggable key={set.id} index={set_idx} draggableId={set.id}>
      {(provided, snapshot) => (
        <div className={`c-define-set ${snapshot.isDragging ? "--ondrag" : ""}`} isDragging={snapshot.isDragging} ref={provided.innerRef} {...provided.draggableProps}>
          <div className="c-set-title">
            <div></div>
            {/*<div className="c-input-wrapper">
              <span>Name</span>
              <input type="text" style={{ minWidth: 400, backgroundColor: '#fbfbfb', borderWidth: 1, borderColor: '#CECECE', padding: 5, borderStyle:'solid' }} onChange={(e) => setName(e.target.value)}/>
            </div> */}
            {isAdmin && (
              <div className="c-btn-collection">
                <div className="c-set-trash-icon" onClick={() => removeSet(set_idx)}>
                  <Icon icon="trash" size={16} />
                </div>
                <div className="c-set-move-icon" {...provided.dragHandleProps}>
                  <Icon icon="move" />
                </div>
              </div>
            )}
          </div>
          {/* <div className="c-set-item">
            {isAdmin ? (
              <Input placeholder="Full name of superset" label="Name" value={set.name} onChange={(e) => onChange(e, "name", false, set_idx)} error={error && error.type === "set_name" && error.idx === set_idx ? error.message : false} />
            ) : (
              <div className="c-no-admin-input-replace-no-bottom">
                <span>Name</span>
                <p>{set.name}</p>
              </div>
            )}
          </div> */}
          {isAdmin && (
            <div className="c-set-item">
              <Input placeholder="Search exercise" label="Exercises" type="search" searchItems={exercises} onClick={(e) => onClickSearch(e, set_idx)} error={error && error.type === "set_exercises" && error.idx === set_idx ? error.message : false} />
            </div>
          )}

          <Droppable droppableId={set.id} type="child">
            {(provided) => (
              <div className="c-set-exercises" ref={provided.innerRef} {...provided.droppableProps}>
                {set.exercises.map((item, exercise_idx) => (
                  <>
                    <Exercise addSubs={addSubs} setOfFirst={setOfFirst} setSetOfFirst={setSetOfFirst} subexercise={false} setIdx={set_idx} previousValues={previousValues} isPersonal={isPersonal} isAdmin={isAdmin} exercises={exercises} item={item} idx={exercise_idx} removeExercise={(idx) => removeExercise(idx, set_idx)} onChange={(e, type, idx, setidx, subIdx, subex) => {onChange(e, type, idx, setidx, subIdx, subex)}} />
                  </>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
          {/*<div className="c-set-rest">
            {isAdmin ? (
              <>
                <p>Rest after set: </p>
                <input type="number" placeholder="0" value={set.rest_time_in_minutes} onChange={(e) => onChange(e.target.value, "rest_time_in_minutes", false, set_idx)} />
                <p>minutes</p>
              </>
            ) : (
              <p>Rest after set: {set.rest_time_in_minutes} minutes</p>
            )}
          </div>*/}
        </div>
      )}
    </Draggable>
  );
}
